/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Price_Free_PriceInputs */

const en_mk_price_free_price = /** @type {(inputs: Mk_Price_Free_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rp0`)
};

const id_mk_price_free_price = /** @type {(inputs: Mk_Price_Free_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rp0`)
};

/**
* | output |
* | --- |
* | "Rp0" |
*
* @param {Mk_Price_Free_PriceInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_price_free_price = /** @type {((inputs?: Mk_Price_Free_PriceInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Price_Free_PriceInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_price_free_price(inputs)
	return en_mk_price_free_price(inputs)
});